import React from 'react';
import { GridItem, HStack, Stack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../../constants/cypressIds';
import DataTypes from '../../../../../../../../../../../constants/dataTypes';
import { Statuses } from '../../../../../../../../../../../constants/statuses';
import { getDisplayValueForType } from '../../../../../../../../../../../utils/tableUtil';

import LimitTooltip from './LimitTooltip';

const PolicyLimitsGrid = ({ policy, limits = [], alphaNumericProperties = [] }) => (
  <GridItem colSpan={1} justifyContent="right" maxW={350} rowSpan={1}>
    <Stack direction="column" spacing={1}>
      {
          limits.map(limit => {
            let popoverLabel = 'not required';
            const value = limit.value ? `${getDisplayValueForType(Number(limit.value), DataTypes.Monetary)}` : '';
            const maxReq = getDisplayValueForType(limit.maxRequirement, DataTypes.Monetary);

            if (limit.maxRequirement === 0) {
              popoverLabel = 'no limit specified';
            } else if (limit.maxRequirement) {
              popoverLabel = `${maxReq} Required`;
            }

            const isNotReceivedOrUnapproved = [Statuses.NotReceived, Statuses.NotApproved, Statuses.Pending, Statuses.NonCompliant, Statuses.Expired]
              .includes(policy.requirementStatus);

            const isNotReceived = policy.requirementStatus === Statuses.NotReceived;
            const isInsufficient = isNotReceivedOrUnapproved
              && ((parseInt(limit.value, 10) < parseInt(limit.maxRequirement, 10)) || (!limit.value && !!limit.maxRequirement));

            // eslint-disable-next-line no-nested-ternary
            const color = isNotReceived ? 'greyScale.600' : isInsufficient ? 'error.primary.600' : 'greyScale.900';

            return (
              <LimitTooltip
                limitName={limit.insurancePolicyTypeProperty.displayName}
                requiredText={popoverLabel}
              >
                <HStack cursor="pointer">
                  <Text
                    color="greyScale.700"
                    data-cy={CypressIds.policyTypePropertyLimit(limit.insurancePolicyTypePropertyId, isInsufficient ? Statuses.NonCompliant : Statuses.Compliant)}
                    maxW="250px"
                    overflow="hidden"
                    textAlign="right"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    {`${limit.insurancePolicyTypeProperty.displayName}:`}
                  </Text>
                  <Text
                    color={color}
                    maxW="100px"
                    minW="20px"
                    textAlign="left"
                    whiteSpace="nowrap"
                  >
                    {isNotReceived ? maxReq : value}
                  </Text>
                </HStack>
              </LimitTooltip>
            );
          })
        }

      {
          alphaNumericProperties.map(limit => {
            let popoverLabel = 'not required';
            const value = limit.value ?? '';
            const maxReq = limit.maxRequirement;

            if (limit.maxRequirement === '') {
              popoverLabel = 'no limit specified';
            } else if (limit.maxRequirement) {
              popoverLabel = `${maxReq} Required`;
            }

            const isNotReceived = policy.requirementStatus === Statuses.NotReceived;
            const color = isNotReceived ? 'greyScale.600' : 'greyScale.900';

            return (
              <LimitTooltip
                limitName={limit.insurancePolicyTypeProperty.displayName}
                requiredText={popoverLabel}
              >
                <HStack cursor="pointer">
                  <Text
                    color="greyScale.700"
                    maxW="250px"
                    overflow="hidden"
                    textAlign="right"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    {`${limit.insurancePolicyTypeProperty.displayName}:`}
                  </Text>
                  <Text
                    color={color}
                    maxW="100px"
                    minW="20px"
                    textAlign="left"
                    whiteSpace="nowrap"
                  >
                    {isNotReceived ? maxReq : value}
                  </Text>
                </HStack>
              </LimitTooltip>
            );
          })
        }
    </Stack>
  </GridItem>
);

PolicyLimitsGrid.propTypes = {
  policy: PropTypes.shape({
    requirementStatus: PropTypes.string,
    difference: PropTypes.string
  }),
  limits: PropTypes.arrayOf(PropTypes.shape({
    maxRequirement: PropTypes.number,
    insurancePolicyTypeProperty: PropTypes.shape({ displayName: PropTypes.string }),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })),
  alphaNumericProperties: PropTypes.arrayOf(PropTypes.shape({
    maxRequirement: PropTypes.number,
    insurancePolicyTypeProperty: PropTypes.shape({ displayName: PropTypes.string }),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }))
};

export default PolicyLimitsGrid;
